import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { CommonService } from "../../_services/common.service";

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.less']
})
export class LoginFormComponent implements OnInit {
  loginForm: FormGroup;
  URL: string;

  constructor(private router: Router, private formBuilder: FormBuilder, private route: ActivatedRoute, private commonService: CommonService) { }

  ngOnInit() {
    const redirectUrl = this.route.snapshot.queryParams.url;
    this.getAbout(redirectUrl);
  }


  getAbout(redirectUrl) {
    this.commonService.getAbout().pipe().subscribe(data => {
      if (data.code === 200) {
        this.createLoginForm(redirectUrl, data.response.signIn);
      }
    });
  }

  /* Create form for auto login */
  createLoginForm(url: string, signInUrl: any) {
    let form = document.createElement('form');
    form.action = signInUrl;
    form.method = 'POST';
    form.innerHTML = '<input type="hidden" id="RelayState" name="RelayState" value = "' + encodeURIComponent(url) + '" />';
    document.body.append(form);
    form.submit();
  }

  setLoginForm(redirectTo: string) {
    this.loginForm = this.formBuilder.group({
      RelayState: [encodeURIComponent(redirectTo), Validators.required],
    });
  }

  redirectToDeepLink(deepLink: string) {
    if (deepLink) {
      window.location.href = decodeURIComponent(deepLink);
    } else {
      this.router.navigate(['/endpoint'], { queryParams: { page: 1, size: 15 } });
    }
  }
}
